var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [(_vm.isRenderWarningMessage) ? _c('v-stepper-label', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "icon": "warning"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs": "7"
    }
  }, [_c('v-text', {
    attrs: {
      "type": "caption"
    }
  }, [_vm._v("\n            Внимание!"), _c('br'), _vm._v("\n            Заполняйте поля в строгом соответствии с паспортом проверяемого.\n            Перед тем, как нажать кнопку «Выполнить запрос», еще раз\n            внимательно проверьте правильность введенной информации. Деньги за\n            некорректный (содержащий ошибки) запрос не возвращаются.\n          ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "errors": _vm.errors,
      "defaultValues": _vm.defaultValues,
      "validate": function (val) { return _vm.onValidate(val, _vm.agreemenWay === 'crv', !_vm.isIdentificationRequired); },
      "readonly": _vm.isRequestCreating
    },
    on: {
      "submit": _vm.handleSubmit
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(api) {
        return [_c('v-stepper-content', [_c('v-row', [_c('v-col', {
          attrs: {
            "xs": "6"
          }
        }, [(_vm.isRenderOrgInnTitle) ? _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.top",
            value: (1),
            expression: "1",
            modifiers: {
              "top": true
            }
          }]
        }, [_c('v-text', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "type": "caption"
          }
        }, [_vm._v("\n                  Укажите ИНН и выберете подходящую компанию из предложенных\n                  вариантов (или оставьте ИНН как есть, если ничего не\n                  нашлось)\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('ipInn')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "ipInn",
            "type": "number",
            "maxlength": "12",
            "required": _vm.fieldIsRequired('ipInn'),
            "label": "ИНН"
          }
        }, [(_vm.shouldShowCaption) ? _c('template', {
          slot: "caption"
        }, [_c('v-text', {
          attrs: {
            "type": "caption"
          }
        }, [_vm._v("Заполните для получения данных о наличии самозапрета")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('orgInn')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "orgInn",
            "maxlength": "10",
            "required": _vm.fieldIsRender('orgInn'),
            "label": "ИНН",
            "type": "number",
            "items": _vm.dadataOrgs,
            "getItemId": _vm.getOrgInnId,
            "getItemCaption": _vm.getOrgInnItemCaption
          },
          on: {
            "input": _vm.onChangeOrgInn
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isRenderPersonTitle) ? _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.top",
            value: (4),
            expression: "4",
            modifiers: {
              "top": true
            }
          }]
        }, [_c('v-text', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (1),
            expression: "1",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "type": "title"
          }
        }, [_vm._v("\n                  Руководитель компании\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('regions')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "items": _vm.regions,
            "field": "regions",
            "required": _vm.fieldIsRequired('regions'),
            "multiple": true,
            "label": "Регионы",
            "caption": "Можно выбрать максимум два региона или использовать поиск по всем регионам.",
            "maxSelectItems": 2,
            "altItem": {
              id: 0,
              name: 'Все регионы'
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('lastName')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "lastName",
            "required": _vm.fieldIsRequired('lastName'),
            "label": "Фамилия"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('firstName')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "firstName",
            "required": _vm.fieldIsRequired('firstName'),
            "label": "Имя"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('middleName')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "middleName",
            "required": _vm.fieldIsRequired('middleName'),
            "label": "Отчество"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('dateBirth')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "dateBirth",
            "required": _vm.fieldIsRequired('dateBirth'),
            "label": "Дата рождения",
            "caption": "ДД / ММ / ГГГГ",
            "mask": "date"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('placeBirth')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "placeBirth",
            "required": _vm.fieldIsRequired('placeBirth'),
            "label": "Место рождения",
            "maxlength": "200"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('position')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "position",
            "required": _vm.fieldIsRequired('position'),
            "label": "Должность"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isRenderPassport) ? _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.top",
            value: (4),
            expression: "4",
            modifiers: {
              "top": true
            }
          }]
        }, [_c('v-text', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (1),
            expression: "1",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "type": "title"
          }
        }, [_vm._v(" Паспорт ")])], 1) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('documentSeries')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "documentSeries",
            "type": "number",
            "maxlength": "4",
            "required": _vm.fieldIsRequired('documentSeries'),
            "label": "Паспорт серия"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('documentNumber')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "documentNumber",
            "type": "number",
            "maxlength": "6",
            "required": _vm.fieldIsRequired('documentNumber'),
            "label": "Паспорт номер"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('issuingAuthority')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "issuingAuthority",
            "required": _vm.fieldIsRequired('issuingAuthority'),
            "label": "Кем выдан"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('issuingDate')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "issuingDate",
            "required": _vm.fieldIsRequired('issuingDate'),
            "label": "Когда выдан",
            "caption": "ДД / ММ / ГГГГ",
            "mask": "date"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('authorityCode')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "authorityCode",
            "type": "number",
            "required": _vm.fieldIsRequired('authorityCode'),
            "label": "Код подразделения",
            "mask": "issuingAuthorityDepartment"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('actualityMonthLimitCount')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "actualityMonthLimitCount",
            "select": "",
            "items": [{
                name: 'Без ограничения',
                value: null
              },
              {
                name: 'Год',
                value: 12
              },
              {
                name: 'Полгода',
                value: 6
              },
              {
                name: '3 месяца',
                value: 3
              },
              {
                name: 'Месяц',
                value: 1
              } ],
            "label": "Границы поиска",
            "required": _vm.fieldIsRequired('actualityMonthLimitCount')
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('searchByRelatedPeople')) ? _c('v-form-checkbox', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "data": "true",
            "disabled": _vm.needVerification,
            "field": "searchByRelatedPeople",
            "required": _vm.fieldIsRequired('searchByRelatedPeople')
          },
          scopedSlots: _vm._u([{
            key: "label",
            fn: function(label) {
              return [_c('v-text', [_vm._v(" Искать по связанным лицам ")])]
            }
          }])
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('income')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "income",
            "type": "number",
            "maxlength": "10",
            "required": _vm.fieldIsRequired('income'),
            "label": "Доход в месяц"
          },
          scopedSlots: _vm._u([{
            key: "caption",
            fn: function(caption) {
              return [_c('v-font-icon', {
                attrs: {
                  "grey": ""
                }
              }, [_vm._v("error_outline")]), _vm._v(" "), _c('span', {
                directives: [{
                  name: "margin",
                  rawName: "v-margin.left",
                  value: (1),
                  expression: "1",
                  modifiers: {
                    "left": true
                  }
                }]
              }, [_vm._v("Для расчёта долговой нагрузки")])]
            }
          }])
        }) : _vm._e(), _vm._v(" "), (_vm.isRenderDriverLicenseTitle) ? _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.top",
            value: (4),
            expression: "4",
            modifiers: {
              "top": true
            }
          }]
        }, [_c('v-text', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (1),
            expression: "1",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "type": "title"
          }
        }, [_vm._v("\n                  Водительское удостоверение\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('driverLicense')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "driverLicense",
            "required": _vm.fieldIsRequired('driverLicense'),
            "label": "Серия и номер ВУ",
            "mask": "driverLicense"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('driverLicenseIssued')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "driverLicenseIssued",
            "required": _vm.fieldIsRequired('driverLicenseIssued'),
            "label": "Дата выдачи ВУ",
            "caption": "ДД / ММ / ГГГГ",
            "mask": "date"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isRenderCarTransportTitle) ? _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.top",
            value: (4),
            expression: "4",
            modifiers: {
              "top": true
            }
          }]
        }, [_c('v-text', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (1),
            expression: "1",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "type": "title"
          }
        }, [_vm._v("\n                  Транспортное средство\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('vehicleLicensePlate')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "vehicleLicensePlate",
            "required": _vm.fieldIsRequired('vehicleLicensePlate'),
            "label": "Государственный регистрационный знак",
            "mask": "vehicleLicensePlate"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('vehicleRegistrationCertificate')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "vehicleRegistrationCertificate",
            "required": _vm.fieldIsRequired('vehicleRegistrationCertificate'),
            "label": "СТС (свидетельство о регистрации ТС)",
            "mask": "vehicleRegistrationCertificate"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('vin')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "vin",
            "required": _vm.fieldIsRequired('vin'),
            "label": "VIN транспортного средства",
            "mask": "vin"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isRenderPropTitle) ? _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.top",
            value: (4),
            expression: "4",
            modifiers: {
              "top": true
            }
          }]
        }, [_c('v-text', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (1),
            expression: "1",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "type": "title"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.isIndividual ? "Адрес прописки" : "Юридический адрес") + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('propIndex')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "propIndex",
            "type": "number",
            "maxlength": "6",
            "required": _vm.fieldIsRequired('propIndex'),
            "label": "Индекс"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('propRegion')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "propRegion",
            "items": _vm.regions,
            "required": _vm.fieldIsRequired('propRegion'),
            "label": _vm.isIndividual ? 'Область регистрации' : 'Область (регион)'
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('propCity')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "propCity",
            "required": _vm.fieldIsRequired('propCity'),
            "label": "Город"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('propStreet')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "propStreet",
            "required": _vm.fieldIsRequired('propStreet'),
            "label": "Улица"
          }
        }) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', [(_vm.fieldIsRender('propHouse')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "propHouse",
            "type": "number",
            "maxlength": "4",
            "required": _vm.fieldIsRequired('propHouse'),
            "label": "Дом"
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('v-col', [(_vm.fieldIsRender('propAppartment')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "propAppartment",
            "type": "number",
            "maxlength": "4",
            "required": _vm.fieldIsRequired('propAppartment'),
            "label": _vm.isIndividual ? 'Квартира' : 'Офис'
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('v-col', [(_vm.fieldIsRender('propCorp')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "propCorp",
            "maxlength": "4",
            "required": _vm.fieldIsRequired('propCorp'),
            "label": "Корпус"
          }
        }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.fieldIsRender('sameAddress')) ? _c('v-form-checkbox', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "sameAddress",
            "required": _vm.fieldIsRequired('sameAddress')
          },
          scopedSlots: _vm._u([{
            key: "label",
            fn: function(label) {
              return [_c('v-text', [_vm._v("\n                    Фактический и юридический адрес регистрации совпадают\n                  ")])]
            }
          }])
        }) : _vm._e(), _vm._v(" "), (!api.getValue('sameAddress').length) ? _c('div', [(_vm.isRenderFactTitle) ? _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (1),
            expression: "1",
            modifiers: {
              "bottom": true
            }
          }, {
            name: "margin",
            rawName: "v-margin.top",
            value: (4),
            expression: "4",
            modifiers: {
              "top": true
            }
          }]
        }, [_c('v-text', {
          attrs: {
            "type": "title"
          }
        }, [_vm._v("Фактический адрес")])], 1) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('factIndex')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "factIndex",
            "type": "number",
            "maxlength": "6",
            "required": _vm.fieldIsRequired('factIndex'),
            "label": "Индекс"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('factRegion')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "factRegion",
            "items": _vm.regions,
            "required": _vm.fieldIsRequired('factRegion'),
            "label": _vm.isIndividual ? 'Область проживания' : 'Область (регион)'
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('factCity')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "factCity",
            "required": _vm.fieldIsRequired('factCity'),
            "label": "Город"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('factStreet')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "factStreet",
            "required": _vm.fieldIsRequired('factStreet'),
            "label": "Улица"
          }
        }) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', [(_vm.fieldIsRender('factHouse')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "factHouse",
            "type": "number",
            "maxlength": "4",
            "required": _vm.fieldIsRequired('factHouse'),
            "label": "Дом"
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('v-col', [(_vm.fieldIsRender('factAppartment')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "factAppartment",
            "type": "number",
            "maxlength": "4",
            "required": _vm.fieldIsRequired('factAppartment'),
            "label": _vm.isIndividual ? 'Квартира' : 'Офис'
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('v-col', [(_vm.fieldIsRender('factCorp')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "factCorp",
            "maxlength": "4",
            "required": _vm.fieldIsRequired('factCorp'),
            "label": "Корпус"
          }
        }) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('orgName')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "orgName",
            "required": _vm.fieldIsRequired('orgName'),
            "label": "Название организации"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('orgOgrn')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "orgOgrn",
            "type": "number",
            "maxlength": "13",
            "required": _vm.fieldIsRequired('orgOgrn'),
            "label": "ОГРН"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('okato')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "okato",
            "type": "number",
            "maxlength": "11",
            "required": _vm.fieldIsRequired('okato'),
            "label": "ОКАТО"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('fias')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }, {
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "fias",
            "required": _vm.fieldIsRequired('fias'),
            "label": "ФИАС"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('innOrOgrn')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "innOrOgrn",
            "type": "number",
            "maxlength": "13",
            "required": _vm.fieldIsRender('innOrOgrn'),
            "label": "ИНН или ОГРН"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.productData.identificationRequired) ? _c('div', {
          class: _vm.theme.checkBtn
        }, [_c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (3),
            expression: "3",
            modifiers: {
              "bottom": true
            }
          }]
        }, [_c('v-text', {
          attrs: {
            "type": "subheadling"
          }
        }, [_vm._v("Заявление-согласие ")])], 1), _vm._v(" "), _c('div', [_c('v-text', [_vm._v("Запрос основной части кредитной истории в бюро кредитных\n                    историй может осуществляться только с согласия субъекта\n                    кредитной истории")])], 1), _vm._v(" "), (
          _vm.productData.availableAgreementTypes.length > 1 &&
          _vm.needVerification
        ) ? _c('v-row', {
          directives: [{
            name: "margin",
            rawName: "v-margin.top",
            value: (3),
            expression: "3",
            modifiers: {
              "top": true
            }
          }]
        }, [_c('v-col', {
          attrs: {
            "xs": "7"
          }
        }, [_c('v-form-radio', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "agreemenWay",
            "data": 'crv',
            "label": "Электронное согласие",
            "clickEvent": _vm.changeAgreemenWay
          }
        })], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "xs": "5"
          }
        }, [_c('v-form-radio', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "agreemenWay",
            "data": 'paper',
            "label": "Скан-копия",
            "clickEvent": _vm.changeAgreemenWay
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.agreemenWay === null) ? _c('v-button', {
          attrs: {
            "type": "button",
            "primary": "",
            "disabled": _vm.checkHasCrvLoading ||
              api.isInvalid ||
              _vm.isRequestCreating ||
              _vm.isInvalidIdentification
          },
          on: {
            "click": function () { return _vm.checkHasCrv(api.getValues()); }
          }
        }, [_vm._v("\n                  Проверить наличие согласия.\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
          _vm.agreemenWay === 'crv' && _vm.needVerification && !_vm.isPhoneCorrect
        ) ? _c('div', {
          directives: [{
            name: "padding",
            rawName: "v-padding.top",
            value: (3),
            expression: "3",
            modifiers: {
              "top": true
            }
          }, {
            name: "padding",
            rawName: "v-padding.bottom",
            value: (3),
            expression: "3",
            modifiers: {
              "bottom": true
            }
          }]
        }, [_c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }]
        }, [_c('v-text', [_vm._v("\n                    По СМС будет отправлена инструкция для прохождения удаленной идентификации\n                  ")])], 1), _vm._v(" "), _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "field": "phone",
            "mask": "phone",
            "label": "Контактный номер проверяемого лица",
            "required": true
          },
          scopedSlots: _vm._u([{
            key: "caption",
            fn: function(props) {
              return [(_vm.isPhoneCorrect === false) ? _c('span', [_vm._v("\n                      Функционал временно недоступен, для выполнения запроса\n                      просим приложить бумажное согласие.\n                    ")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), (_vm.agreemenWay === 'crv' && _vm.needVerification) ? _c('div', [(_vm.isPhoneCorrect) ? _c('div', [_c('v-text', [_vm._v("\n                      Телефон найден. Нажмите \"Запросить согласие\" и мы\n                      выполним запрос сразу, как субъект даст согласие на\n                      получение данных из Кредитного Бюро.\n                    ")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-button', {
          attrs: {
            "type": "button",
            "primary": "",
            "disabled": _vm.checkHasPhoneLoading ||
              _vm.isInvalidIdentification ||
              api.isInvalid ||
              // ссаный костыль, потому что я не знаю, как в vue с динамической валидацией дружит
              !api.getValue('phone') ||
              api.getValue('phone').length !== 18 ||
              Boolean(_vm.timerId)
          },
          on: {
            "click": function () { return _vm.checkPhoneCompatibility(api.getValues()); }
          }
        }, [_vm._v("\n                  Проверить возможность\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.agreemenWay === 'paper' && _vm.needVerification) ? _c('div', {
          directives: [{
            name: "padding",
            rawName: "v-padding.top",
            value: (3),
            expression: "3",
            modifiers: {
              "top": true
            }
          }, {
            name: "padding",
            rawName: "v-padding.bottom",
            value: (3),
            expression: "3",
            modifiers: {
              "bottom": true
            }
          }]
        }, [_c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }]
        }, [(api.isInvalid) ? _c('v-text', {
          attrs: {
            "error": ""
          }
        }, [_vm._v("\n                    Чтобы скачать сформированное заявление-согласие,\n                    необходимо заполнить обязательные поля\n                  ")]) : _c('v-text', [_vm._v("\n                    Скачайте уже заполненное заявление-согласие в удобном\n                    формате\n                  ")])], 1), _vm._v(" "), _c('div', [_c('v-text', {
          directives: [{
            name: "margin",
            rawName: "v-margin.right",
            value: (3),
            expression: "3",
            modifiers: {
              "right": true
            }
          }]
        }, [_c('v-font-icon', {
          attrs: {
            "grey": "",
            "disabled": api.isInvalid
          }
        }, [_vm._v("file_download")]), _vm._v(" "), _c('v-link', {
          attrs: {
            "disabled": api.isInvalid,
            "to": "javascript:;"
          },
          on: {
            "click": function($event) {
              _vm.downloadContract('doc', api.getValues())
            }
          }
        }, [_vm._v("\n                      DOC\n                    ")])], 1), _vm._v(" "), _c('v-text', {
          directives: [{
            name: "margin",
            rawName: "v-margin.right",
            value: (3),
            expression: "3",
            modifiers: {
              "right": true
            }
          }]
        }, [_c('v-font-icon', {
          attrs: {
            "grey": "",
            "disabled": api.isInvalid
          }
        }, [_vm._v("file_download")]), _vm._v(" "), _c('v-link', {
          attrs: {
            "disabled": api.isInvalid,
            "to": "javascript:;"
          },
          on: {
            "click": function($event) {
              _vm.downloadContract('html', api.getValues())
            }
          }
        }, [_vm._v("\n                      HTML\n                    ")])], 1), _vm._v(" "), _c('v-text', [_c('v-font-icon', {
          attrs: {
            "grey": "",
            "disabled": api.isInvalid
          }
        }, [_vm._v("file_download")]), _vm._v(" "), _c('v-link', {
          attrs: {
            "disabled": api.isInvalid,
            "to": "javascript:;"
          },
          on: {
            "click": function($event) {
              _vm.downloadContract('pdf', api.getValues())
            }
          }
        }, [_vm._v("\n                      PDF\n                    ")])], 1)], 1), _vm._v(" "), (_vm.fieldIsRender('contractScan')) ? _c('v-form-file', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "loader": _vm.loaders.contractScan,
            "files": _vm.scans.contractScan,
            "field": "contractScan",
            "label": "Прикрепите скан заявления *",
            "caption": "Прикрепите заявление-согласие, заполненное и подписанное от руки.\n                                      Файлы: pdf, jpg, jpeg, png, tiff, tif 14Мб"
          },
          on: {
            "upload": function($event) {
              _vm.handleUploadScan('contractScan', $event)
            },
            "remove": function($event) {
              _vm.handleRemoveScan('contractScan', $event)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('passportScan')) ? _c('v-form-file', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "loader": _vm.loaders.passportScan,
            "files": _vm.scans.passportScan,
            "field": "passportScan",
            "label": "Прикрепите скан паспорта *",
            "caption": "Прикрепите разворот с фотографией и прописку.\n                                      Файлы: pdf, jpg, jpeg, png, gif, tiff, tif 14Мб"
          },
          on: {
            "upload": function($event) {
              _vm.handleUploadScan('passportScan', $event)
            },
            "remove": function($event) {
              _vm.handleRemoveScan('passportScan', $event)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('ogrnScan')) ? _c('v-form-file', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "loader": _vm.loaders.ogrnScan,
            "files": _vm.scans.ogrnScan,
            "field": "ogrnScan",
            "label": "Прикрепите ОГРН *",
            "caption": "Загрузите скан ОГРН.\n                                      Файлы: pdf, jpg, jpeg, png, gif, tiff, tif 14Мб"
          },
          on: {
            "upload": function($event) {
              _vm.handleUploadScan('ogrnScan', $event)
            },
            "remove": function($event) {
              _vm.handleRemoveScan('ogrnScan', $event)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('attorneyScan')) ? _c('v-form-file', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "loader": _vm.loaders.attorneyScan,
            "files": _vm.scans.attorneyScan,
            "field": "attorneyScan",
            "label": "Прикрепите скан доверенности *",
            "caption": "Загрузите скан доверенности, если заявление-согласие подписал не директор.\n                                      Файлы: pdf, jpg, jpeg, png, gif, tiff, tif 14Мб"
          },
          on: {
            "upload": function($event) {
              _vm.handleUploadScan('attorneyScan', $event)
            },
            "remove": function($event) {
              _vm.handleRemoveScan('attorneyScan', $event)
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('monitoringEndDate')) ? _c('v-form-input', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "disabled": _vm.needVerification,
            "field": "monitoringEndDate",
            "required": _vm.fieldIsRequired('monitoringEndDate'),
            "label": "Дата окончания мониторинга",
            "caption": "ММ/ГГГГ",
            "mask": "dateWithoutDay",
            "placeholder": "ММ/ГГГГ"
          },
          on: {
            "input": _vm.onMonitoringDateChange
          }
        }) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('monitoringEndDate') && _vm.monitoringDateError) ? _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "error-message"
        }, [_c('v-text', {
          staticStyle: {
            "color": "#ff4444"
          },
          attrs: {
            "error": "",
            "type": "caption"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.monitoringDateError) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.fieldIsRender('monitoringEndDate')) ? _c('div', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }]
        }, [_c('v-text', {
          attrs: {
            "type": "caption"
          }
        }, [_vm._v("\n                  Мониторинг действует по конец выбранного месяца включительно.\n                ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isIdentificationRequired) ? _c('div', [_c('v-text', {
          attrs: {
            "type": "caption"
          }
        }, [_c('v-link', {
          attrs: {
            "to": "https://exbico.ru/page97982866.html",
            "target": "_blank"
          }
        }, [_vm._v("\n                    Поручение на обработку ПД\n                    "), _c('v-font-icon', {
          attrs: {
            "small": "",
            "inherit": ""
          }
        }, [_vm._v("\n                      description\n                    ")])], 1), _vm._v(" "), _c('v-link', {
          attrs: {
            "to": "https://exbico.ru/politika_konfdencialnosti",
            "target": "_blank"
          }
        }, [_vm._v("\n                    Политика обработки ПД\n                    "), _c('v-font-icon', {
          attrs: {
            "small": "",
            "inherit": ""
          }
        }, [_vm._v("\n                      description\n                    ")])], 1)], 1), _vm._v(" "), _c('v-form-checkbox', {
          directives: [{
            name: "margin",
            rawName: "v-margin.bottom",
            value: (2),
            expression: "2",
            modifiers: {
              "bottom": true
            }
          }],
          attrs: {
            "data": "true",
            "field": "agreementReceived",
            "required": true
          },
          scopedSlots: _vm._u([{
            key: "label",
            fn: function(label) {
              return [_c('v-text', [_vm._v(" Получено согласие субъекта на обработку его перс. данных. ")])]
            }
          }])
        })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-label', {
          attrs: {
            "icon": "error"
          }
        }, [_c('v-text', {
          attrs: {
            "type": "subheadling"
          }
        }, [_vm._v(" Итого: " + _vm._s(_vm.calculatedTotal) + " руб ")])], 1), _vm._v(" "), _c('div', [(
          !_vm.productData.identificationRequired ||
          _vm.agreementId !== null ||
          (_vm.needVerification &&
            (_vm.isPhoneCorrect || _vm.agreemenWay === 'paper'))
        ) ? _c('v-stepper-content', [_c('v-spinner', {
          attrs: {
            "active": _vm.isRequestCreating
          }
        }, [_c('v-button', {
          attrs: {
            "type": "submit",
            "primary": "",
            "disabled": api.isInvalid ||
              !_vm.isFormValid ||
              _vm.isRequestCreating ||
              _vm.isInvalidIdentification
          }
        }, [_vm._v("\n                Запросить отчет\n              ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isBackendError) ? _c('v-stepper-label', {
          attrs: {
            "icon": "warning",
            "danger": true
          }
        }, [_c('v-text', {
          attrs: {
            "type": "caption",
            "danger": true
          }
        }, [_vm._v(" " + _vm._s(_vm.backendErrorMessage) + " ")])], 1) : _vm._e()]
      }
    }])
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-683357f8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/requestProfile/RequestProfile.vue
// module id = 1088
// module chunks = 0